import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { WindowWidthContext } from "../App";

function Landing() {
  const windowWidth = useContext(WindowWidthContext);

  useEffect(() => {
    if (windowWidth > 1400) {
      const tl = gsap.timeline();
      tl.set(".home__landing__content, .home__landing__img", {
        visibility: "visible",
      })
        .from(".home__landing__content", {
          scaleY: 0,
          duration: 0.8,
          transformOrigin: "bottom",
        })
        .from(
          ".home__landing__content h1, .home__landing__content p, .home__landing__content button",
          { opacity: 0, x: -50, duration: 0.8 }
        )
        .from(
          ".home__landing__img",
          { duration: 0.8, x: 100, opacity: 0 },
          0.8
        );
    } else if (windowWidth > 800 && windowWidth <= 1400) {
      const tl = gsap.timeline();
      tl.set(".home__landing__content", { visibility: "visible" })
        .from(".home__landing__content", {
          scaleY: 0,
          duration: 0.8,
          transformOrigin: "bottom",
        })
        .from(
          ".home__landing__content h1, .home__landing__content p, .home__landing__content button",
          { opacity: 0, x: -50, duration: 0.8 }
        );
    } else if (windowWidth <= 800) {
      const tl = gsap.timeline();
      tl.set(".home__landing__content", { visibility: "visible" })
        .from(
          ".home__landing__content h1",
          {
            opacity: 0,
            y: 50,
            duration: 0.8,
          },
          1
        )
        .from(
          ".home__landing__content p",
          {
            opacity: 0,
            y: 50,
            duration: 0.8,
          },
          1.2
        )
        .from(
          ".home__landing__content button",
          {
            opacity: 0,
            y: 50,
            duration: 0.8,
          },
          1.4
        );
    }
  }, []);

  useEffect(() => {
    if (windowWidth > 1400) {
      gsap.set(".home__landing__img", { visibility: "visible" });
    }
  }, [windowWidth]);

  return (
    <div className="home__landing">
      <div className="home__landing__content">
        <h1>
          Lorem Ipsum is simply dummy text of the printing and typesetting
        </h1>
        <p>
          Industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting,
          remaining essentially unchanged. It was popularised
        </p>
        <Link to="/gallery">
          <button>
            Look All Pictures<span></span>
          </button>
        </Link>
      </div>
      <div className="home__landing__img">
        <img src="/images/landing.webp" />
      </div>
    </div>
  );
}

export default Landing;
